module.exports = __webpack_public_path__ + "34cb6e103fd49cafe3187b89e038aa88.svg";